import {NoticeTypeEnum} from "../../models/notice";
import RootStore from "../root-store";

export default abstract class BaseStore {
    public rootStore: RootStore;

    protected constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    protected notify(type: NoticeTypeEnum, message: any) {
        this.rootStore.toasterStore.addNotice({type: type, message: message.toString()});
    }
}



// WEBPACK FOOTER //
// ./src/stores/base/base-store.ts